import React, { useEffect, useRef, useState, useContext } from 'react';

import Markup from '../../markup';
import BuilderContext from "../../builder/hooks/context";

type Props = {
  width?: number,
  offset?: number,
  borderRadius?: number,
  top?: boolean,
  bottom?: boolean,
  children: any,
  Icon: any
};

function Tooltip(
  { Icon, width, top, bottom, offset, borderRadius, children }: Props) {
  const [active, setActive] = useState(false);
  const [arrowOffset, setArrowOffset] = useState(0);
  const iconEl = useRef(null);
  const contentEl = useRef(null);
  const { builder } = useContext(BuilderContext);

  useEffect(() => {
    if (contentEl.current && active) {
      setArrowOffset(Math.abs(contentEl?.current.offsetLeft) + iconEl.current.offsetWidth / 2 - (top ? 0 : 16));
    }
  }, [contentEl, iconEl, active]);

  return (
    <>
      <Markup.Global.Tooltip.Container>
        <Icon active={active} ref={iconEl} onClick={() => setActive(prev => !prev)} themeColor={builder.membersData.colorTheme} checkSurface={builder.modelData.surffaceList.length}/>
        {active && <Markup.Global.Tooltip.Content ref={contentEl} borderRadius={borderRadius} arrowOffset={arrowOffset} offset={offset} top={top} bottom={bottom} width={width} active={active}>{children}</Markup.Global.Tooltip.Content>}
      </Markup.Global.Tooltip.Container>
      {active && <Markup.Global.Tooltip.Layout onClick={() => setActive(false)} />}
    </>
  );
}

export default React.memo(Tooltip);
